// extracted by mini-css-extract-plugin
export default {"details":"meRiOMz07hLBAxGZms+C-g==","detail":"Fsh9RwYlHFY1sFOFMCPpTA==","label":"AjUd28i8jeqRUtcCNiwIdw==","DE":"AW1IJzcGtCasjH1Cr2w4uw=="};